/* Overrides for api.jquery.js (v3.1, 30 September 2026). The cart drawer
   markup lives only in snippets/mini-cart-drawer.liquid; assets/nad-v3.js
   re-renders it through the Section Rendering API (window.plCartRefresh).
   This file no longer builds drawer lines from a template string: the old
   string used the legacy .cart-plus-minus stepper, which collapsed. */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart);
};

Shopify.cartUpdateInfo = function(cart) {
  if (cart && typeof cart.item_count === 'number') {
    jQuery(".bigcounter").html(cart.item_count);
  }
  if (typeof window.plCartRefresh === 'function') {
    window.plCartRefresh();
  }
};

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
